import React from 'react';

export default function FormFieldError({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <div className="flex gap-1 items-center text-red text-xs">
      <span className="flex justify-center items-center w-2 h-2 rounded-full bg-red text-white text-[6px]/[1em] mb-[1px]">
        <span className="heading">!</span>
      </span>
      <span>{message}</span>
    </div>
  );
}
